import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import IconButton from 'components/common/IconButton';
import Avatar from 'components/common/Avatar';
import Menu, { MenuItem } from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import IconMoreVert from 'components/icons/IconMoreVert';
import Link from 'components/common/Link';

import sortRoles from 'utils/sortRoles';
import splitLongWords from 'utils/splitLongWords';

import { deleteUser } from 'redux/modules/users';

const styles = () => ({
  avatar: {
    display: 'inline-block',
    verticalAlign: 'middle',
    width: 32,
    height: 32,
    marginRight: 15,
  },
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  tableCellRoles: {
    maxWidth: 200,
  },
});

class UsersTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      deleteMenuOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onDeleteMenuItemClick = this.onDeleteMenuItemClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      deleteMenuOpen: false,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onDeleteMenuItemClick() {
    this.setState({ deleteMenuOpen: true });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { ID } = this.props;
    this.props.actions.deleteUser({ ID });
    this.setState({
      deleteMenuOpen: false,
      anchorEl: null,
    });
  }

  render() {
    const { history, classes } = this.props;
    const roles = sortRoles(this.props.Roles);
    const open = Boolean(this.state.anchorEl);
    let imageSrc;
    if (Object.keys(this.props.Image).length > 0) {
      imageSrc = process.env.REACT_APP_API_ROOT
        ? `${process.env.REACT_APP_API_ROOT}${this.props.Image['File Url']}${this.props.Image['File Name']}`
        : `${this.props.Image['File Url']}${this.props.Image['File Name']}`;
    }

    return (
      <TableRow>
        <TableCell>
          <Link
            breakWord
            href={`/settings/users/${this.props.ID}`}
          >
            <Avatar
              className={classes.avatar}
              src={imageSrc}
              color="light"
            />
            {splitLongWords(`${this.props['First Name']} ${this.props['Last Name']}`)}
          </Link>
        </TableCell>
        <TableCell className={classes.tableCellRoles}>
          {roles.map(item => item.Name).join(', ')}
        </TableCell>
        <TableCell>
          {splitLongWords(this.props.Email, 40)}
        </TableCell>
        <TableCell>
          {' '}
        </TableCell>
        <TableCell>
          {this.props.Active ? 'Active' : 'Inactive'}
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            aria-label="More"
            aria-owns={open ? `${this.props.ID}-user-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert className={classes.iconMoreVert} />
          </IconButton>
          <Menu
            id={`${this.props.ID}-user-menu`}
            anchorEl={this.state.anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={!this.state.deleteMenuOpen}
            maxHeight={130}
          >
            {this.state.deleteMenuOpen ? (
              <DeleteMenu
                text="Are you sure you want to delete this user?"
                onCancel={this.onDeleteCancel}
                onSubmit={this.onDeleteSubmit}
              />
            ) : (
              <Fragment>
                <MenuItem
                  onClick={() => {
                    history.push(`/settings/users/${this.props.ID}`);
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem onClick={this.onDeleteMenuItemClick} color="warning">
                  Delete
                </MenuItem>
              </Fragment>
            )}
          </Menu>
        </TableCell>
      </TableRow>
    );
  }
}

UsersTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  'First Name': PropTypes.string.isRequired,
  'Last Name': PropTypes.string.isRequired,
  Roles: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    Name: PropTypes.string,
  })).isRequired,
  Email: PropTypes.string.isRequired,
  Active: PropTypes.bool.isRequired,
  Image: PropTypes.shape({
    'File Url': PropTypes.string,
    'File Name': PropTypes.string,
  }).isRequired,
  actions: PropTypes.shape({
    deleteUser: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
    buttonCell: PropTypes.string.isRequired,
    tableCellRoles: PropTypes.string.isRequired,
  }).isRequired,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deleteUser }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withRouter(withStyles(styles)(UsersTableRow)),
);



// WEBPACK FOOTER //
// ./src/components/settings/UsersTable/UsersTableRow.js